<template>
  <div class="flex items-center justify-center track-container w-100 relative mw-100 overflow-hidden" :class="{'justify-between': inPlayer}">
    <div class="flex items-center justify-start">
      <div v-show="track.picture" class="track-picture flex item-center justify-center" :style="{'padding': inPlayer ? '2.5px' : '0'}">
        <img class="w-100 h-100" :src="picture">
        <img v-show="track == currentTrack && !inPlayer && isPlaying"
            class="track-picture-vinyl vinyl-rotation top-50 left-50 z-2 w-70" src="../../assets/vinyl-record.svg" alt="playing track">
      </div>
      <div class="mw-100" :class="{'track-data' : !inPlayer}">
        <h1 :class="{ 'player-track-info' : inPlayer }" class="track-info f6 f5-ns fw6 lh-title mv0 mw-100 textColor">{{(track.isAd)? $t('ads.advertisingSpace') : track.title }}</h1>
        <h2 v-if="inModal === true" :class="{ 'player-track-info' : inPlayer }" class="track-info f6 fw4 mt0 mb0 mw-100 textColor">{{track && !track.artist ? track.name : track.artist.name}}</h2>
        <router-link v-if="inPlayer === true" :to="{ name:'artist-info', params:{ id:track.id_artist }}" class="text-width textColor no-underline">
          <h2 :class="{ 'player-track-info' : inPlayer }" class="track-info f6 fw4 mt0 mb0 mw-100 textColor">{{track && !track.artist ? track.name : track.artist.name}}</h2>
        </router-link>
      </div>
    </div>
    <div v-show="!inPlayerPlaylist && !currentTrack.isAd">
      <track-options-button :inPlayer="true" :track="track"/>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import consts from '@/consts'
  import TrackOptionsButton from '@/components/tracks/TrackOptionsButton.vue'

  export default {
    name: 'track-info',
    props: {
      track: {
        required: true
      },
      inPlayer: {
        defaut: false
      },
      inModal: {
        defaut: false
      },
      inPlayerPlaylist: {
        defaut: false
      }
    },
    components: {
      TrackOptionsButton
    },
    computed: {
      ...mapGetters('player', [
        'currentTrack',
        'isPlaying'
      ]),
      picture () {
        let trackPicture = ''
        if (!/\/uploads\/tracks\//.test(this.track.picture)) {
          trackPicture = '/uploads/tracks/' + this.track.picture
        } else {
          trackPicture = this.track.picture
        }
        if (trackPicture === '/uploads/tracks//static/assets/track4.jpg') {
          return consts.MEDIA_BASE_URL + '/static/assets/track4.jpg'
        }
        return consts.MEDIA_BASE_URL + trackPicture
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';
  .track-container {
    flex-grow: 1;
  }

  .track-picture {
    height: 45px;
    width: 45px;
    min-height: 45px;
    min-width: 45px;
    max-height: 45px;
    max-width: 45px;
    margin-left: 5px;
  }

  .track-picture-vinyl {
    max-width: inherit;
    max-height: inherit;
    position: absolute;
  }

  .track-info {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .player-track-info{
    max-width: 55vw;
  }

  .track-data {
    margin-left: 10px;
    max-width: 20vw;
  }

  @media screen and (min-width: 1440px) {
    .track-data {
      max-width: 10vw;
    }
  }

  @media screen and (max-width: 479px) {
    .player-track-info {
      max-width: 35vw;
    }
    .track-data {
      font-size: .75rem;
      max-width: 75vw;
    }
  }

  @media screen and (min-width: 480px) and (max-width: 779px) {
    .player-track-info {
      max-width:35vw;
    }
    .track-data {
      max-width: 35vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tracks/TrackInfo.vue